import React from 'react'
import { Col, Row } from 'reactstrap'

const PathogenContactInfo = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-md-5 py-4'>
            <Row className=''>
                <Col md='12' lg='7' className=''>
                    <div className=''>
                        <div className=''>
                            <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh- pb-2'>
                                About United Lab Care
                            </div>
                            <hr className='hr-style mb-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>

                        <div className='pt-2 pb-3'>
                            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                            We are a Medical Laboratory based out of Lombard, IL, since. We service the entire Chicagoland area and offer the highest quality, patient service, direct communication, and professionalism! Our expert team has been appropriately trained and certified and has years of experience handling all your testing needs.
                            </div>
                        </div>

                        <div className='pb-2'>
                            <div className='fs-ss-22 text-montserrat text-ss-primary fw-700 lh- pb-2'>
                                Who to Test With United Lab Care:
                            </div>
                        </div>

                        <div className='pb-3'>
                            <div className='fs-ss-15-1 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                            The Infectious Disease Society of America (IDSA) recommends the following for the testing of COVID-195 in symptomatic individuals:
                            </div>
                        </div>

                        <div className='pb-2'>
                            <ul className='fs-ss-15-1 text-montserrat fw-600 text-ss-black ps-md-3' style={{ letterSpacing:'0.5px'}}>
                                <li className=''>Test if COVID-19 is suspected</li>
                                
                                <li className=''>Test once if clinical suspicion is low</li>
                                
                                <li className=''>Repeat testing if the initial test is negative and clinical suspicion is moderate to high</li>
                            </ul>
                        </div>

                        <div className=''>
                            <div className='fs-ss-22 text-montserrat text-ss-primary fw-700 lh- pb-2'>
                                Sample Storage:
                            </div>
                        </div>

                        <div className='pb-3'>
                            <div className='fs-ss-15-1 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                Specimens should be processed and tested with United Lab Care as soon as possible. If storage is required, specimens can be held at:
                            </div>
                        </div>

                        <div className='pb-2'>
                            <ul className='fs-ss-15-1 text-montserrat fw-600 text-ss-black ps-md-3' style={{ letterSpacing:'0.5px'}}>
                                <li className=''>Room temperature up to 4 hours (15-25 °C)</li> 
                                <li className=''>Refrigerated for up to 3 days (2-8 °C)</li> 
                                <li className=''>Frozen (≤-15 °C or ≤-70 °C) (for up to 30 days)</li> 
                            </ul>
                        </div>
                    </div>
                </Col>

                <Col sm='12' md='12' lg='5' className='d-flex justify-content-center'>
                    <div className='bg-im bg-size' style={{ backgroundImage:'url("pathogen-testing/Contact-Us-bg-v2.png")', backgroundSize:'', height:'%', width:'%', backgroundRepeat:'no-repeat', padding:''}}>
                    <div className='ptop-img' style={{ textAlign:'center', paddingTop:''}}>
                        <div className=''>
                            <div className='fs-ss-20 text-montserrat fw-700 text-white'>
                                Phone
                            </div>
                        </div>

                        <div className='pb-md-5 pb-3'>
                            <a href='tel: (800) 442-1663' style={{ textDecoration:'none'}} className='fs-ss-18 text-montserrat fw-600 text-white'>
                                (800) 442-1663
                            </a>
                        </div>

                        <div className=''>
                            <div className='fs-ss-20 text-montserrat fw-700 text-white'>
                                Email
                            </div>
                        </div>

                        <div className='pb-md-5 pb-3'>
                            <a href='mailto: info@unitedlabcare.com' style={{ textDecoration:'none'}}  className='fs-ss-18 text-montserrat fw-600 text-white'>
                                info@unitedlabcare.com
                            </a>
                        </div>

                        <div className=''>
                            <div className='fs-ss-20 text-montserrat fw-700 text-white'>
                                Location
                            </div>
                        </div>

                        <div className='pb-md-5 pb-3'>
                            <a href='https://www.google.com/maps/dir//246+E+Janata+Blvd+%2315,+Lombard,+IL+60148,+USA/@41.8443086,-88.0473776,13z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0x880e527567ae7583:0xd90c7f477b3ea9b3!2m2!1d-88.0123582!2d41.8443139' rel='noreferrer' target='_blank' style={{ textDecoration:'none'}} className='fs-ss-18 text-montserrat fw-600 text-white display-none'>
                                246 E Janata Blvd # 115, Lombard, 60148 
                            </a>
                            <a href='https://www.google.com/maps/dir//246+E+Janata+Blvd+%2315,+Lombard,+IL+60148,+USA/@41.8443086,-88.0473776,13z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0x880e527567ae7583:0xd90c7f477b3ea9b3!2m2!1d-88.0123582!2d41.8443139' rel='noreferrer' target='_blank' style={{ textDecoration:'none'}} className='fs-ss-18 text-montserrat fw-600 text-white display-block1'>
                                246 E Janata Blvd # 115,<br/> Lombard, 60148 
                            </a>
                        </div>

                        <div className=''>
                            <div className='fs-ss-20 text-montserrat fw-700 text-white'>
                                Hours
                            </div>
                        </div>

                        <div className='pb-md-5 pb-3'>
                            <div className='fs-ss-18 text-montserrat fw-600 text-white display-none'>
                                MONDAY – SATURDAY: 9:00 AM – 6:00 PM 
                            </div>
                            <div className='fs-ss-18 text-montserrat fw-600 text-white display-block1'>
                                MONDAY – SATURDAY:<br/> 9:00 AM – 6:00 PM 
                            </div>
                        </div>

                        <div className=''>
                            <div className='fs-ss-20 text-montserrat fw-700 text-white'>
                                Turn-Around
                            </div>
                        </div>

                        <div className=''>
                            <div className='fs-ss-18 text-montserrat fw-600 text-white'>
                                Only 24 – 48 Hours 
                            </div>
                        </div>
                    </div>
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default PathogenContactInfo